<ion-footer>
  <div class="crossIcon" (click)="modelCtrl.dismiss(active)">
    <ion-icon name="close-outline"></ion-icon>
  </div>
  <ion-card class="content">
    <ion-grid>
      <ion-row class="ion-margin-horizontal">
        <ion-col class="category-item">
          <div class="ion-text-center">
            <ion-img [src]="category.image" class="category-img"></ion-img>
            <p class="ion-text-nowrap category-name">{{ category.name |language: category.name}}</p>
          </div>
        </ion-col>
      </ion-row>
      <ion-row class="ion-margin-horizontal">
        <ion-col class="category-item">
          <div class="ion-text-center">
            <p class="ion-text-nowrap select-label">{{ 'Selecttopitems' |language: 'Select top items'}}</p>
          </div>
        </ion-col>
      </ion-row>
      <ion-row class="ion-margin-horizontal">
        <ion-col class="top-items" size="4">
          <div class="ion-text-center" (click)="addTopItems('10')">
            <ion-img src="/assets/catalog/top10.svg" class="roleImg"></ion-img>
            <p class="ion-text-nowrap">{{'Top10'|language:'Top 10'}}</p>
          </div>
        </ion-col>
        <ion-col class="top-items" size="4" (click)="addTopItems('25')">
          <div class="ion-text-center">
            <ion-img src="/assets/catalog/top25.svg" class="roleImg"></ion-img>
            <p class="ion-text-nowrap">{{'Top25'|language:'Top 25'}}</p>
          </div>
        </ion-col>
        <ion-col class="top-items" size="4" (click)="addTopItems('50')">
          <div class="ion-text-center">
            <ion-img src="/assets/catalog/top50.svg" class="roleImg"></ion-img>
            <p>{{'Top50'|language:'Top 50'}}</p>
          </div>
        </ion-col>

        <ion-col class="top-items" size="4" (click)="addTopItems('75')">
          <div class="ion-text-center">
            <ion-img src="/assets/catalog/top75.svg" class="roleImg"></ion-img>
            <p class="ion-text-nowrap">{{'Top75'|language:'Top 75'}}</p>
          </div>
        </ion-col>
        <ion-col class="top-items" (click)="addTopItems('100')">
          <div class="ion-text-center">
            <ion-img src="/assets/catalog/top100.svg" class="roleImg"></ion-img>
            <p class="ion-text-nowrap">{{'Top100'|language:'Top 100'}}</p>
          </div>
        </ion-col>
        <ion-col size="4">
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card>
</ion-footer>